import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AdminHeader } from '../admin-header/admin-header';
import { AdminSidebar } from '../admin-sidebar/admin-sidebar';

@Component({
  selector: 'app-issue-drug',
  standalone: true,
  imports: [CommonModule, FormsModule, AdminHeader, AdminSidebar],
  templateUrl: './issues-drug.html',
  styleUrls: ['./issues-drug.css']
})
export class IssueDrugComponent implements OnInit {
  baseUrl = 'https://logs.proofile.com.ng/api';
  stores: any[] = [];
  patients: any[] = [];
  filteredPatients: any[] = [];
  stockItems: any[] = [];
  filteredStockItems: any[] = [];
  stockBalance: number | null = null;

  showIssueModal = false;
  isSubmitting = false;
  loadingIssues = false;
  successMessage = '';
  errorMessage = '';
  searchPatient = '';
  drugSearch = '';

  issue = {
    store_id: null,
    stock_item_id: null,
    quantity: null,
    patient_type: 'in-patient',
    patient_id: null,
    note: ''
  };

  recentIssues: any[] = [];
  filteredIssues: any[] = [];
  currentPage = 1;
  pageSize = 10;

  filterStartDate: string = '';
  filterEndDate: string = '';

  constructor(private http: HttpClient) {}

  ngOnInit() {
    this.fetchStores();
    this.fetchPatients();
    this.fetchStockItems();
    this.fetchRecentIssues();
  }

  fetchStores() {
    this.http.get<any[]>(`${this.baseUrl}/stores`).subscribe(data => this.stores = data);
  }

  fetchStockItems() {
    this.http.get<any[]>(`${this.baseUrl}/stock-items`).subscribe(data => {
      this.stockItems = data;
      this.filteredStockItems = data;
    });
  }

  filterDrugs() {
    const term = this.drugSearch.toLowerCase();
    this.filteredStockItems = this.stockItems.filter(item =>
      item.name.toLowerCase().includes(term)
    );
  }

  fetchPatients() {
    this.http.get<any[]>(`${this.baseUrl}/patients`).subscribe(data => {
      this.patients = data;
      this.filteredPatients = data;
    });
  }

  filterPatients() {
    const term = this.searchPatient.toLowerCase();
    this.filteredPatients = this.patients.filter(p =>
      `${p.surname} ${p.other_names} ${p.hospital_id}`.toLowerCase().includes(term)
    );
  }

  checkStockBalance() {
    const { store_id, stock_item_id } = this.issue;
    if (store_id && stock_item_id) {
      this.http.get<any>(`${this.baseUrl}/stock-items/${stock_item_id}`).subscribe({
        next: (res) => this.stockBalance = res.quantity ?? 0,
        error: () => this.stockBalance = null
      });
    } else {
      this.stockBalance = null;
    }
  }

  submitIssue() {
    const { store_id, stock_item_id, patient_id, quantity } = this.issue;
    if (!store_id || !stock_item_id || !patient_id || !quantity) {
      this.errorMessage = 'Please complete all required fields.';
      return;
    }

    this.isSubmitting = true;
    const payload = {
      ...this.issue,
      store_id: Number(store_id),
      stock_item_id: Number(stock_item_id),
      patient_id: Number(patient_id),
      quantity: Number(quantity),
      note: this.issue.note?.trim() || null
    };

    this.http.post(`${this.baseUrl}/product-issues`, payload).subscribe({
      next: () => {
        this.successMessage = '✅ Drug issued successfully!';
        this.resetForm();
        this.fetchRecentIssues();
        setTimeout(() => this.successMessage = '', 3000);
      },
      error: (err) => {
        this.errorMessage = `❌ ${err.error?.message || 'Failed to issue drug.'}`;
      },
      complete: () => this.isSubmitting = false
    });
  }

  resetForm() {
    this.issue = {
      store_id: null,
      stock_item_id: null,
      quantity: null,
      patient_type: 'in-patient',
      patient_id: null,
      note: ''
    };
    this.stockBalance = null;
    this.errorMessage = '';
    this.drugSearch = '';
    this.filteredStockItems = [...this.stockItems];
  }

  fetchRecentIssues() {
    this.loadingIssues = true;
    this.http.get<any[]>(`${this.baseUrl}/product-issues?limit=100`).subscribe({
      next: (data) => {
        this.recentIssues = data;
        this.filteredIssues = data;
        this.applyDateFilter();
        this.loadingIssues = false;
      },
      error: () => {
        this.loadingIssues = false;
        this.errorMessage = 'Failed to load recent issues.';
      }
    });
  }

  applyDateFilter() {
    if (!this.filterStartDate && !this.filterEndDate) {
      this.filteredIssues = [...this.recentIssues];
      return;
    }

    const start = this.filterStartDate ? new Date(this.filterStartDate) : new Date('2000-01-01');
    const end = this.filterEndDate ? new Date(this.filterEndDate) : new Date();

    this.filteredIssues = this.recentIssues.filter(issue => {
      const issueDate = new Date(issue.created_at);
      return issueDate >= start && issueDate <= end;
    });
  }

  paginatedIssues() {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.filteredIssues.slice(start, start + this.pageSize);
  }
}
